import {configure} from 'mobx';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {pdfjs} from 'react-pdf';
import {RecoilRoot} from 'recoil';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import {setGlobalRequestHandlers} from './api/utilities/globalRequestHandlers';
import {Application} from './application/Application';
import {globalRequestHandlers} from './utils';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

configure({enforceActions: 'observed'});

setGlobalRequestHandlers(globalRequestHandlers);

const root = createRoot(document.getElementById('root')!);
root.render(
  <>
    <RecoilRoot>
      <Application />
    </RecoilRoot>
  </>
);
